import React from 'react';
import './updatePrompt.css';

// Shown when a new build has been downloaded and is sitting in "waiting".
//
// The reload is user-initiated on purpose. Activating a new worker swaps the
// JS bundle, so doing it automatically would blow away whatever half-filled
// form or unsaved note the user had open — which on this app can be a full
// inspection write-up.
function UpdatePrompt({ registration, onDismiss }) {
  const [reloading, setReloading] = React.useState(false);

  const handleReload = () => {
    const waiting = registration && registration.waiting;
    if (!waiting) {
      window.location.reload();
      return;
    }

    setReloading(true);

    // Reload once the new worker has actually taken control, rather than
    // straight after postMessage — reloading too early just re-loads the old
    // bundle from the old worker and the prompt comes back.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    }, { once: true });

    waiting.postMessage({ type: 'SKIP_WAITING' });
  };

  return (
    <div className="update-prompt" role="status" aria-live="polite">
      <span className="update-prompt__text">A new version of Artemis is ready.</span>
      <div className="update-prompt__actions">
        <button
          type="button"
          className="update-prompt__reload"
          onClick={handleReload}
          disabled={reloading}
        >
          {reloading ? 'Updating…' : 'Reload'}
        </button>
        <button type="button" className="update-prompt__dismiss" onClick={onDismiss}>
          Later
        </button>
      </div>
    </div>
  );
}

export default UpdatePrompt;
